<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="container-fluid whopperco-container">
      <div class="row window-height">

        <!-- LEFT: Form -->
        <div class="col-12 col-md-6 left-bg">
          <div class="inner-left-wrap p-3 p-md-4">
            <div class="text-center mb-3 anim-fade-in" style="animation-delay: 0.1s">
              <img src="/signup-img/whopperco/bk-logo.png" alt="Burger King" class="bk-logo" />
            </div>
            <div class="text-center mb-3 anim-fade-in" style="animation-delay: 0.2s">
              <p class="whopperco-wordmark mb-0">WHOPPERCO</p>
              <p class="whopperco-tagline">Franchise Training Portal</p>
            </div>

            <div class="signin-header anim-slide-up" style="animation-delay: 0.3s">
              <h3 class="mb-0">Set Your Password <img src="/signup-img/fire.svg" alt="" /></h3>
              <span class="d-block mb-4">First-time sign-in — choose a new password.</span>
            </div>

            <form role="form" @submit.prevent="onSubmit" novalidate class="anim-slide-up" style="animation-delay: 0.4s">
              <div class="pass-wrap position-relative mb-3">
                <input
                  id="newPassword"
                  v-model="form.newPassword"
                  :type="passwordFieldType"
                  autocomplete="new-password"
                  placeholder="New password (8+ characters)"
                  class="form-control login-input singup-input"
                />
                <span class="eye-icon-pass" @click="togglePassword">
                  <svg v-if="passwordFieldType === 'password'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 3l18 18M10.6 10.6a3 3 0 0 0 4.2 4.2M9.5 5.4A11 11 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.4 4.4M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7c1.6 0 3-.3 4.3-.8" />
                  </svg>
                  <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
                    <circle cx="12" cy="12" r="3" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </div>

              <div class="mb-3">
                <input
                  id="confirmPassword"
                  v-model="form.confirmPassword"
                  :type="passwordFieldType"
                  autocomplete="new-password"
                  placeholder="Confirm password"
                  class="form-control login-input singup-input"
                />
              </div>

              <div class="d-flex justify-content-center signinbtn mb-3 mt-4">
                <button type="submit" class="btn d-block w-100" :disabled="loading">
                  <span v-if="!loading">Save and Continue</span>
                  <span v-else>Saving…</span>
                </button>
              </div>

              <p v-if="error" class="error">{{ error }}</p>
              <p v-if="saved" class="success">Password updated. Taking you to onboarding…</p>

              <p class="signin-link text-center mb-0 mt-3" v-if="!saved">
                <router-link to="/login" class="font-weight-bold">Back to sign in</router-link>
              </p>
            </form>

            <div class="text-center mt-3 anim-fade-in" style="animation-delay: 0.7s">
              <img src="/signup-img/whopperco/hot-logo.png" alt="Home of Training" class="hot-logo" />
            </div>
          </div>
        </div>

        <!-- RIGHT: Hero -->
        <div class="col-12 col-md-6 right-bg">
          <div class="inner-right-wrap d-flex flex-column h-100 pt-5 pl-2 pl-md-5 pr-2 pr-md-5">
            <div class="mb-3 anim-fade-in" style="animation-delay: 0.2s">
              <img src="/signup-img/whopperco/hot-logo.png" alt="Home of Training" class="hot-logo-hero" />
            </div>
            <h2 class="text-white mb-2 anim-slide-up" style="animation-delay: 0.3s">
              One quick step. Then you're in.
            </h2>
            <p class="text-white mb-4 anim-slide-up" style="animation-delay: 0.45s">
              Your default password is your date of birth. Pick something only you know — minimum 8 characters.
            </p>

            <div class="hero-checklist anim-slide-up" style="animation-delay: 0.55s">
              <div class="hero-check-item">✓ At least 8 characters</div>
              <div class="hero-check-item">✓ Different from your DOB</div>
              <div class="hero-check-item">✓ You'll use this every shift</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhopperChangePassword',
  data() {
    return {
      form: { newPassword: '', confirmPassword: '' },
      passwordFieldType: 'password',
      loading: false,
      saved: false,
      error: ''
    };
  },
  methods: {
    togglePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      this.error = '';
      if (!this.form.newPassword || !this.form.confirmPassword) {
        this.error = 'Both fields are required.';
        return;
      }
      if (this.form.newPassword.length < 8) {
        this.error = 'Password must be at least 8 characters.';
        return;
      }
      if (this.form.newPassword !== this.form.confirmPassword) {
        this.error = 'Passwords do not match.';
        return;
      }
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.saved = true;
        setTimeout(() => this.$router.push('/whopperco/onboarding'), 1100);
      }, 800);
    }
  }
};
</script>

<style scoped>
html, body, .window-height { min-height: 100vh; }
.whopperco-container { font-family: "Inter", "Nunito", sans-serif; color: #1e1e1e; }

.left-bg {
  background: #f3f3f3 url("/signup-img/signup_bg1.svg") no-repeat right bottom;
  background-size: contain;
  display: flex; align-items: flex-start; padding-top: 3vh;
  min-height: 100vh;
}
.inner-left-wrap { width: 100%; max-width: 460px; margin: 0 auto; }

.bk-logo { max-width: 110px; height: auto; }
.whopperco-wordmark { font-size: 22px; font-weight: 800; letter-spacing: 4px; color: #502314; line-height: 1.1; margin: 0; }
.whopperco-tagline { font-size: 12px; font-weight: 600; color: #6b7280; letter-spacing: 1.5px; text-transform: uppercase; margin: 4px 0 0; }

.signin-header h3 { font-size: 32px; font-weight: 700; color: #1e1e1e; line-height: 40px; }
.signin-header h3 img { margin-left: 4px; vertical-align: middle; height: 28px; }
.signin-header span { font-size: 15px; color: #6b7280; }

.singup-input {
  border: 1.5px solid #e5e7eb; border-radius: 10px; padding: 14px 16px;
  font-size: 15px; height: auto; background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.singup-input:focus {
  outline: none; border-color: #ea2628;
  box-shadow: 0 0 0 4px rgba(234, 38, 40, 0.1);
}

.pass-wrap .eye-icon-pass {
  position: absolute; right: 14px; top: 50%; transform: translateY(-50%);
  cursor: pointer; z-index: 2;
}

.signinbtn .btn {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  border: 0; height: clamp(46px, 6vw, 56px); font-size: clamp(17px, 2vw, 20px);
  font-weight: 600; color: #fff; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; gap: 10px;
  letter-spacing: 0.3px; transition: opacity 0.2s, transform 0.15s;
}
.signinbtn .btn:hover { opacity: 0.92; }
.signinbtn .btn:disabled { opacity: 0.6; cursor: not-allowed; }

.signin-link { font-size: 14px; color: #6b7280; }
.signin-link a { color: #ea2628; }

.hot-logo { max-width: 80px; height: auto; opacity: 0.7; }

.error { color: #ea2628; text-align: center; font-size: 13px; margin-top: 12px; }
.success { color: #15803d; text-align: center; font-size: 14px; font-weight: 600; margin-top: 12px; }

.right-bg {
  background:
    radial-gradient(circle at 20% 20%, rgba(255, 209, 92, 0.18) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(0, 0, 0, 0.25) 0%, transparent 60%),
    linear-gradient(135deg, #ea2628 0%, #c01618 100%);
  min-height: 100vh; position: relative; overflow: hidden;
}
.right-bg::before {
  content: ""; position: absolute; top: -120px; right: -120px;
  width: 380px; height: 380px;
  background: radial-gradient(circle, rgba(255, 209, 92, 0.35) 0%, transparent 65%);
  filter: blur(40px); pointer-events: none;
}
.hot-logo-hero {
  max-width: 220px; height: auto;
  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.3)) brightness(0) invert(1);
}
.inner-right-wrap { position: relative; z-index: 1; }
.inner-right-wrap h2 { font-size: 38px; font-weight: 800; line-height: 1.1; letter-spacing: -0.5px; }
.inner-right-wrap p { font-size: 17px; max-width: 88%; opacity: 0.92; line-height: 1.45; }

.hero-checklist { display: flex; flex-direction: column; gap: 10px; margin-top: 8px; }
.hero-check-item {
  color: #fff; font-weight: 600; font-size: 15px;
  background: rgba(255, 255, 255, 0.1); padding: 12px 18px;
  border-radius: 10px; backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
@keyframes btnGlow { 0%, 100% { box-shadow: 0 0 0 0 rgba(228, 142, 57, 0); } 50% { box-shadow: 0 0 24px 5px rgba(234, 38, 40, 0.28); } }

.anim-fade-in { opacity: 0; animation: fadeIn 0.6s ease-out forwards; }
.anim-slide-up { opacity: 0; animation: slideUp 0.6s ease-out forwards; }
.signinbtn .btn { animation: btnGlow 2.5s ease-in-out 1s infinite; }

@media (max-width: 768px) {
  .right-bg { padding: 32px 16px; min-height: auto; }
  .inner-right-wrap h2 { font-size: 28px; }
}
</style>
